import Vue from 'vue'
// eslint-disable-next-line import/no-named-as-default
import FunctionalCalendar from 'vue-functional-calendar'

if (!Vue.options.components.FunctionalCalendar) {
  Vue.use(FunctionalCalendar, {
    tagName: 'FunctionalCalendar'
  })
}
